import { createReducer } from '@reduxjs/toolkit';
import { lifecycleSurveyTriggerActions } from '~/behaviors/actions/lifecycleSurveyTrigger.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';

const defaultState = {};

const reset = () => defaultState;

const remove = (state, { payload }) => {
  const id = payload?.id;
  if (!id) return state;

  const { [id]: deleted, ...rest } = state;
  return rest;
};

const merge = (state, { payload }) => {
  const entries = payload?.entities?.lifecycleSurveyTriggers;
  if (!entries) return;

  Object.values(entries).forEach((entry) => {
    // @ts-ignore @TODO Epic WT-21600
    state[entry.id] = { ...state[entry.id], ...entry };
  });
};

const lifecycleSurveyTriggers = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(lifecycleSurveyTriggerActions.upsertLifecycleSurveyTrigger.fulfilled, merge)
    .addCase(lifecycleSurveyTriggerActions.getLifecycleSurveyTriggers.fulfilled, merge)
    .addCase(lifecycleSurveyTriggerActions.deleteLifecycleSurveyTrigger.fulfilled, remove);
});

export default lifecycleSurveyTriggers;
